/**
 * Sidebar state constants
 */
export const SIDEBAR_STATE = {
    COLLAPSED: 0,
    VISIBLE: 1
};

